/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

//images
import templarTumbnail from "assets/images/products/TemplarTumb.png";
import LicencaTumbnail from "assets/images/products/LicencaTumb.png";

function Produtos_Grade() {
  const callHardware = {
    type: "internal",
    route: "/pages/produtos/templar",
    color: "dark",
    label: "Saiba mais",
  };
  
  const callSoftware = {
    type: "internal",
    route: "/pages/produtos/licencas",
    color: "dark",
    label: "Saiba mais",
  };

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid
          container
          item
          flexDirection="column"
          alignItems="center"
          xs={12}
          lg={6}
          sx={{ textAlign: "center", mx: "auto" }}
        >
        <MKTypography variant="h2" mb={4}>
            Explore nossos produtos{" "}
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Soluções desenhadas com exclusividade para atender necessidades específicas de cada cliente, seja no âmbito do software ou do hardware, buscando
            sempre a correta implementação para lhe atender.
          </MKTypography>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }} justifyContent={"center"}>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={templarTumbnail}
                title="MDC-SR10 V2 TEMPLAR"
                description="O centro de comunicações Templar é um dos mais avançados data centers para garantir a sua segurança cibernética."
                action={callHardware}
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={LicencaTumbnail}
                title="Software - Licenças"
                description="Através de nossas parcerias nós somos capazes de facilitar a aquisição de licenças de software."
                action={callSoftware}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Produtos_Grade;
